import { render, staticRenderFns } from "./ProfileCompany.vue?vue&type=template&id=8a5ca642&scoped=true"
import script from "./ProfileCompany.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileCompany.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileCompany.vue?vue&type=style&index=0&id=8a5ca642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5ca642",
  null
  
)

export default component.exports